var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './document-preview.styles';
let PDocumentPreview = class PDocumentPreview extends LitElement {
    constructor() {
        super(...arguments);
        this.currentView = 'full-page';
    }
    static { this.styles = styles; }
    /**
     * Attribute changed callback
     *
     * @param {string} name Name
     * @param {string} oldValue Old value
     * @param {string} newValue New value
     * @returns {void}
     */
    async attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'file-id' && this.fileId) {
            this.pages = await this.getPages(newValue);
            this.requestUpdate();
        }
    }
    /**
     * Get pages
     * @param {string} fileId - file id
     * @returns {Array} Pages
     */
    async getPages(fileId) {
        this.accessToken = window.getAccessToken();
        this.pages = [];
        try {
            const response = await fetch(`${process.env.API_URL}/file/${fileId}/pages?fields=all&access_token=${this.accessToken}`);
            if (response.status === 404) {
                return [];
            }
            const json = await response.json();
            return json;
        }
        catch (e) {
            console.error(e);
        }
        return [];
    }
    /**
     * Render component
     * @returns {TemplateResult} Template
     */
    render() {
        return html ` <div class="document-preview"> <div class="stage ${this.currentView}"> ${this.pages?.map((page, index) => html `
              <div class="page" data-number=${index + 1} id="page-${index + 1}">
                <img alt="page-${index + 1}" src=${page.url} loading="lazy" />
              </div>
            `)}
        </div>
      </div>
    `;
    }
};
__decorate([
    property({ type: String, reflect: true, attribute: 'file-id' })
], PDocumentPreview.prototype, "fileId", void 0);
PDocumentPreview = __decorate([
    customElement('p-document-preview')
    /**
     * PDocumentPreview component
     *
     * @class PDocumentPreview
     * @typedef {PDocumentPreview}
     * @extends {LitElement}
     */
], PDocumentPreview);
export { PDocumentPreview };
